/**
 * @deprecated
 */

// import PATHS from 'src/router/paths'

const columns = {
  // [PATHS.REPORTS.ADX_HEALTH]: [
  //   {
  //     align: 'start',
  //     class: 'date',
  //     columnName: 'Date',
  //     columnValue: (item) => item.date,
  //     exportAs: ['date', 'L'],
  //     formatAs: 'date',
  //     key: 'date',
  //     sortable: true,
  //     tooltip: 'Date',
  //     transform: false,
  //     width: 120,
  //   },
  //   {
  //     align: 'start',
  //     class: 'top-level-ad-unit-code',
  //     columnName: 'Ad ID',
  //     columnValue: (item) => item.topLevelAdUnitCode,
  //     exportOnly: false,
  //     key: 'topLevelAdUnitCode',
  //     sortable: true,
  //     tooltip: 'Top-Level Ad Unit ID',
  //     transform: false,
  //     visible: false,
  //     width: 120,
  //   },
  //   {
  //     align: 'start',
  //     class: 'top-level-ad-unit-name',
  //     columnName: 'Ad Name',
  //     columnValue: (item) => item.topLevelAdUnitName,
  //     key: 'topLevelAdUnitName',
  //     sortable: true,
  //     tooltip: 'Top-Level Ad Unit Name',
  //     transform: false,
  //     width: 180,
  //   },
  //   {
  //     align: 'start',
  //     class: 'device-category',
  //     columnName: 'Device',
  //     columnValue: (item) => item.deviceCategory,
  //     key: 'deviceCategory',
  //     sortable: true,
  //     tooltip: 'Device Category',
  //     transform: false,
  //     width: 120,
  //   },
  //   {
  //     align: 'start',
  //     class: 'inventory-size',
  //     columnName: 'Size',
  //     columnValue: (item) => {
  //       const { inventorySize } = item
  //       if (!inventorySize) return 'Not Set'
  //       if (Array.isArray(inventorySize)) return inventorySize.join(', ')
  //       return inventorySize
  //     },
  //     key: 'inventorySize',
  //     sortable: true,
  //     tooltip: 'Size',
  //     transform: "(value) => value.split(',')",
  //     width: 180,
  //   },
  //   {
  //     align: 'start',
  //     class: 'ad-requests',
  //     columnName: 'Ad Requests',
  //     columnValue: (item) => item.adRequests,
  //     exportAs: 'number',
  //     formatAs: 'number',
  //     key: 'adRequests',
  //     sortable: true,
  //     tooltip: 'Ad Requests',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'matched-requests',
  //     columnName: 'Matched Requests',
  //     columnValue: (item) => item.matchedRequests,
  //     exportAs: 'number',
  //     formatAs: 'number',
  //     key: 'matchedRequests',
  //     sortable: true,
  //     tooltip: 'Matched Requests',
  //     transform: false,
  //     width: 186,
  //   },
  //   {
  //     align: 'start',
  //     class: 'coverage',
  //     columnName: 'Coverage',
  //     columnValue: (item) => item.coverage,
  //     formatAs: 'percentage',
  //     key: 'coverage',
  //     sortable: true,
  //     tooltip: 'Coverage',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'ad-impressions',
  //     columnName: 'Impressions',
  //     columnValue: (item) => item.adImpressions,
  //     exportAs: 'number',
  //     formatAs: 'number',
  //     key: 'adImpressions',
  //     sortable: true,
  //     tooltip: 'Impressions',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'ad-impressions-percentage',
  //     columnName: 'Imps %',
  //     columnValue: (item) => item.adImpressionPerc,
  //     formatAs: 'percentage',
  //     key: 'adImpressionPerc',
  //     sortable: true,
  //     tooltip: 'Impressions %',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'ad-ecpm',
  //     columnName: 'eCPM',
  //     columnValue: (item) => item.adEcpm,
  //     formatAs: 'currency',
  //     key: 'adEcpm',
  //     sortable: true,
  //     tooltip: 'eCPM',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'estimated-revenue',
  //     columnName: 'Est. Revenue',
  //     columnValue: (item) => item.estimatedRevenue,
  //     formatAs: 'dollars',
  //     key: 'estimatedRevenue',
  //     sortable: true,
  //     tooltip: 'Estimated Revenue',
  //     transform: false,
  //     width: 150,
  //   },
  // ],
  // [PATHS.REPORTS.NETWORK_HEALTH]: [
  //   {
  //     align: 'start',
  //     class: 'date',
  //     columnName: 'Date',
  //     columnValue: (item) => item.date,
  //     exportAs: ['date', 'L'],
  //     formatAs: 'date',
  //     key: 'date',
  //     sortable: true,
  //     tooltip: 'Date',
  //     transform: false,
  //     width: 120,
  //   },
  //   {
  //     align: 'start',
  //     class: 'ad-unit-code',
  //     columnName: 'Ad ID',
  //     columnValue: (item) => item.topLevelAdUnitCode,
  //     exportOnly: false,
  //     key: 'topLevelAdUnitCode',
  //     sortable: true,
  //     tooltip: 'Top-Level Ad Unit ID',
  //     transform: false,
  //     visible: false,
  //     width: 120,
  //   },
  //   {
  //     align: 'start',
  //     class: 'ad-unit-name',
  //     columnName: 'Ad Name',
  //     columnValue: (item) => item.topLevelAdUnitName,
  //     key: 'topLevelAdUnitName',
  //     sortable: true,
  //     tooltip: 'Top-Level Ad Unit Name',
  //     transform: false,
  //     width: 180,
  //   },
  //   {
  //     align: 'start',
  //     class: 'device-category',
  //     columnName: 'Device',
  //     columnValue: (item) => item.deviceCategoryName,
  //     key: 'deviceCategoryName',
  //     sortable: true,
  //     tooltip: 'Device Category',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'requested-ad-sizes',
  //     columnName: 'Requested Sizes',
  //     columnValue: (item) => {
  //       const { requestedAdSizes } = item
  //       if (!requestedAdSizes) return 'Not Set'
  //       if (Array.isArray(requestedAdSizes)) return requestedAdSizes.join(', ')
  //       return requestedAdSizes
  //     },
  //     key: 'requestedAdSizes',
  //     sortable: true,
  //     tooltip: 'Requested Sizes',
  //     transform: "(value) => value.split(',')",
  //     width: 212,
  //   },
  //   {
  //     align: 'start',
  //     class: 'unfilled-impressions',
  //     columnName: 'Unfilled Imps',
  //     columnValue: (item) => item.unfilledImpressions,
  //     exportAs: 'number',
  //     formatAs: 'number',
  //     key: 'unfilledImpressions',
  //     sortable: true,
  //     tooltip: 'Unfilled Impressions. Sourced from GAM.',
  //     transform: false,
  //     width: 153,
  //   },
  //   {
  //     align: 'start',
  //     class: 'total-impressions',
  //     columnName: 'Total Imps',
  //     columnValue: (item) => item.totalImpressions,
  //     exportAs: 'number',
  //     formatAs: 'number',
  //     key: 'totalImpressions',
  //     sortable: true,
  //     tooltip: 'Total Imps',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'all-impressions',
  //     columnName: 'All Imps',
  //     columnValue: (item) => item.allImpressions,
  //     exportAs: 'number',
  //     formatAs: 'number',
  //     key: 'allImpressions',
  //     sortable: true,
  //     tooltip: 'All Impressions',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'unfilled-percentage',
  //     columnName: 'Unfilled %',
  //     columnValue: (item) => item.unfilledPercentage,
  //     formatAs: 'percentage',
  //     key: 'unfilledPercentage',
  //     sortable: true,
  //     tooltip: 'Unfilled Percentage',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'gross-revenue',
  //     columnName: 'Est. Revenue',
  //     columnValue: (item) => item.revenue,
  //     formatAs: 'dollars',
  //     key: 'revenue',
  //     sortable: true,
  //     tooltip: 'Estimated Revenue. Sourced from GAM.',
  //     transform: false,
  //     width: 150,
  //   },
  // ],
  // [PATHS.REPORTS.YIELD_PARTNER]: [
  //   {
  //     align: 'start',
  //     class: 'date',
  //     columnName: 'Date',
  //     columnValue: (item) => item.date,
  //     exportAs: ['date', 'L'],
  //     formatAs: 'date',
  //     key: 'date',
  //     sortable: true,
  //     tooltip: 'Date',
  //     transform: false,
  //     width: 120,
  //   },
  //   {
  //     align: 'start',
  //     class: 'week',
  //     columnName: 'Week',
  //     columnValue: (item) => item.week,
  //     formatAs: 'number',
  //     key: 'week',
  //     sortable: true,
  //     tooltip: 'Week',
  //     transform: false,
  //     visible: false,
  //     width: 90,
  //   },
  //   {
  //     align: 'start',
  //     class: 'demand-channel-code',
  //     columnName: 'DCID',
  //     columnValue: (item) => item.demandChannelCode,
  //     key: 'demandChannelCode',
  //     sortable: true,
  //     tooltip: 'DCID',
  //     transform: false,
  //     visible: false,
  //     width: 102,
  //   },
  //   {
  //     align: 'start',
  //     class: 'demand-channel-name',
  //     columnName: 'Demand Channel',
  //     columnValue: (item) => item.demandChannelName,
  //     key: 'demandChannelName',
  //     sortable: true,
  //     tooltip: 'Demand Channel',
  //     transform: false,
  //     width: 180,
  //   },
  //   {
  //     align: 'start',
  //     class: 'yield-partner',
  //     columnName: 'Yield Partner',
  //     columnValue: (item) => {
  //       const { yieldPartner } = item
  //       const isGoogle = yieldPartner === null
  //       return isGoogle ? 'Google' : String(yieldPartner)
  //     },
  //     key: 'yieldPartner',
  //     sortable: true,
  //     tooltip: 'Yield Partner',
  //     transform: false,
  //     width: 160,
  //   },
  //   {
  //     align: 'start',
  //     class: 'yield-impressions',
  //     columnName: 'Impressions',
  //     columnValue: (item) => item.yieldImpressions,
  //     exportAs: 'number',
  //     formatAs: 'number',
  //     key: 'yieldImpressions',
  //     sortable: true,
  //     tooltip: 'Impressions',
  //     transform: false,
  //     width: 160,
  //   },
  //   {
  //     align: 'start',
  //     class: 'yield-ecpm',
  //     columnName: 'eCPM',
  //     columnValue: (item) => item.yieldEstimatedCPM,
  //     formatAs: 'currency',
  //     key: 'yieldEstimatedCPM',
  //     sortable: true,
  //     tooltip: 'eCPM',
  //     transform: false,
  //     width: 150,
  //   },
  //   {
  //     align: 'start',
  //     class: 'yield-revenue',
  //     columnName: 'Revenue',
  //     columnValue: (item) => item.yieldEstimatedRevenue,
  //     formatAs: 'dollars',
  //     key: 'yieldEstimatedRevenue',
  //     sortable: true,
  //     tooltip: 'Revenue',
  //     transform: false,
  //     width: 160,
  //   },
  // ],
}

export default columns
